import { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { UiModal } from 'src/components/UI/modal/UiModal';
import { useBemHelper } from 'src/utils/hooks/useBemHelper';
import { IconWarning } from 'src/components/Icons/WarningIcon';
import { useTHelper } from 'src/utils/i18n';
import { PlusSubscriptionModalButton } from 'src/components/plusSubscription/modals/components/Button';
import { closePlusSubscriptionModal } from 'src/store/plusSubscription/helpers';
import { PlusSubscriptionModalSwitchButton } from 'src/components/plusSubscription/modals/components/SwitchButton';
import { PlusSubscriptionPaymentFailedSelector } from 'src/store/plusSubscription/selectors';
import { CDate } from 'src/utils/CDate';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';

type Props = {
  canClose: boolean;
};

export const PlusSubscriptionPaymentFailedModal: FC<Props> = ({ canClose }) => {
  const bemHelper = useBemHelper('plus-subscription-modal-payment-failed');

  const tHelper = useTHelper('plusSubscription.modals.paymentFailed');

  const model = useSelector(PlusSubscriptionPaymentFailedSelector);
  const { Name } = useSelector(deCommonCurrentPartnerSelector);

  return (
    <UiModal
      disableClose={!canClose}
      onHide={closePlusSubscriptionModal}
      header={
        <div className={bemHelper('header')}>
          <IconWarning className={bemHelper('header-icon')} />
          <span className={bemHelper('header-text')}>{tHelper('title')}</span>
        </div>
      }
      /* eslint-disable-next-line react/no-unstable-nested-components */
      customFooter={() => (
        <div className={bemHelper('footer')}>
          <div className={bemHelper('footer-row')}>
            <UiOuterLink
              href={model.ChargebeeSelfServePortalUrl}
              className={classNames(
                'plus-subscription-modal-button plus-subscription-modal-button_filled',
                bemHelper('footer-button')
              )}
            >
              {tHelper('button.fixIssue')}
            </UiOuterLink>
            {!model.IsGracePeriodExpired && (
              <PlusSubscriptionModalButton
                onClick={closePlusSubscriptionModal}
                className={bemHelper('footer-button')}
                bordered
              >
                {tHelper('button.fixLater')}
              </PlusSubscriptionModalButton>
            )}
          </div>

          <PlusSubscriptionModalSwitchButton className={bemHelper('footer-button')} noBorder partnerName={Name}>
            {tHelper('button.cancel')}
          </PlusSubscriptionModalSwitchButton>
        </div>
      )}
      modalClassName={bemHelper()}
      backdropClassName="plus-subscription-modal-payment-failed-backdrop"
    >
      <div className={bemHelper('text')}>{model.FailedPaymentReason}</div>
      <div className={bemHelper('text')}>
        {model.IsGracePeriodExpired
          ? tHelper('expiredText', { partner: Name })
          : tHelper('text', { date: CDate.formatStringToDate(model.GracePeriodExpirationDate) || '' })}
      </div>
    </UiModal>
  );
};
